import { render, staticRenderFns } from "./RadarChartSkeletonLoader.vue?vue&type=template&id=79bb5c7d&scoped=true&"
import script from "./RadarChartSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./RadarChartSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./RadarChartSkeletonLoader.vue?vue&type=style&index=0&id=79bb5c7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bb5c7d",
  null
  
)

export default component.exports